import type { PropsWithChildren } from "react";

import { useAtomsDevtools } from "jotai-devtools";

export const StateDevTools = ({ children }: PropsWithChildren) => {
  useAtomsDevtools("jotai");

  return children;
};
